import { createReducer, on } from '@ngrx/store';

import { ChatChannelListActions } from './chat-channel-list.actions';
import { initialState } from './chat-channel-list.types';

export const chatChannelListReducer = createReducer(
  initialState,

  // Update Chat Settings
  on(ChatChannelListActions.updateChatSettingsSuccess, (state, { settings }) => ({
    ...state,
    chatSettings: settings,
  })),
);
